import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { withStyles } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { FinalReport } from "../models";
import { AdminTable } from "../../home/models";

import TextField from "../../common/TextField";
import CheckboxGroup from "../../common/CheckboxGroup";
import PartnersContactList from "../../common/PartnersContactList";
import HelpLabel from "../../common/HelpLabel";
import Select from "../../common/Select";
import states from "../../common/states.json";
import { MAKE_OPTIONS } from "../../../api/constants";
import { getValue } from "../../../api/utils";

const styles = theme => ({
    rightAlign: {
        textAlign: "right"
    },
    button: {
        marginRight: theme.spacing(2)
    },
    gutterTop: {
        textAlign: "center",
        marginTop: ".6em"
    },
    checkbox: {
        border: "1px solid",
        padding: 10,
        paddingBottom: 0,
        "&:hover": {
            backgroundColor: "#eee"
        }
    }
});

class GeneralTab extends Component {
    typingTimer = [];

    componentDidMount() {
        const { handleUnsavedFields } = this.props;
        document.title = "Final Report: General - Lessard Sams Outdoor Heritage Council";
        this.props.onRef(this);
        const _this = this;
        // FIXME: react-forms calls formDidUpdate when (if) validation is ran right away
        // making it appear there is a edited field even if there isn't
        // Reset fields to false to not require validation when mounted
        setTimeout(function () {
            handleUnsavedFields(false);
            _this.props.appContainer.current.scrollTop();
        }, 1);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name),
            ml_year: isRequired(values.ml_year)
        };

        return valObj;
    };

    updateAP(values, fromStepper) {
        const { ormFinalReportUpdate, history, handleUnsavedFields, handleNext, final_report } = this.props;
        const { id } = final_report;

        if (Number.isInteger(fromStepper)) {
            values.activeStep = fromStepper;
        }

        values.modify_date_label = final_report.modify_date_label;
        values.signup_criteria = final_report.signup_criteria;

        ormFinalReportUpdate({
            id: id,
            ...values
        });

        handleUnsavedFields(false);

        if (!Number.isInteger(fromStepper)) {
            if (this.state.draftClick) {
                history.push("/dashboard/");
            } else {
                handleNext();
            }
        }
    };

    editAppropriation = (value, fieldname) => {
        const { ormAdminTableUpdate } = this.props;
        const { admin_id } = this.props.accomplishment_plan;

        clearTimeout(this.typingTimer[fieldname]);
        this.typingTimer[fieldname] = setTimeout(function () {
            ormAdminTableUpdate({
                id: admin_id,
                [fieldname]: value
            });
        }, 1000);
    };

    applyActivityOther = (value, fieldname) => {
        const { ormFinalReportUpdateLocalOnly } = this.props;
        const { id } = this.props.final_report;
        ormFinalReportUpdateLocalOnly({
            id: id,
            [fieldname]: value
        });
        this.setState({ foo: "bar" });
    };

    render() {
        const { classes, final_report, budgets, handleUnsavedFields, settings, ActionMenu, authState } = this.props;
        var is_read_only = true;
        if ((authState && authState.user && authState.user.role === "admin") || final_report.status === "Draft")
            is_read_only = false;
        if (authState && authState.user && authState.user.role === "readonly")
            is_read_only = true;

        const showOther = getValue(final_report, "activity_types").indexOf("Other") > -1;

        return (
            <Form
                getApi={el => (this.form = el)}
                key={final_report.id}
                dontValidateOnMount={true}
                validateOnSubmit={true}
                defaultValues={final_report.formData}
                formDidUpdate={() => handleUnsavedFields(true)}
                validateError={values => this.errorValidator(values)}
                onSubmit={(values, fromStepper) => this.updateAP(values, fromStepper)}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={10} lg={12} xl={10}>
                                <HelpLabel
                                    inputLabel="Management Information"
                                    title={true}
                                    showLabel={true}
                                    helpText={settings.general_tab_help}
                                />
                                {ActionMenu}
                            </Grid>
                            <Grid item xs={12} md={10} lg={8} xl={6}>
                                <TextField disabled={is_read_only} field="name" fullWidth>
                                    <HelpLabel
                                        inputLabel="Project or Program Title"
                                        showLabel={true}
                                        helpText="Project or Program Title should be descriptive and include the correct program phase, if applicable."
                                    />
                                </TextField>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField field="ml_year" label="Session Year" readOnly fullWidth />
                                        <TextField
                                            field="funds_recommended" useTextFormat
                                            fullWidth readOnly>
                                            <HelpLabel
                                                inputLabel="Funds Recommended ($)"
                                                showLabel={true}
                                                helpText="The funds appropriated to this program."
                                            />
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField field="create_date_label" label="Created Date" fullWidth readOnly />
                                        <TextField field="modify_date_label" label="Modified Date" readOnly fullWidth />
                                    </Grid>
                                </Grid>
                                <Typography variant="h3" className={classes.gutterTop}>
                                    Organization
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField disabled={is_read_only} field="manager_name" label="Manager's Name" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_title" label="Title" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_organization" label="Organization Name" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_address" label="Address" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_address2" label="Address 2" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_city" label="City" fullWidth />
                                        <Select disabled={is_read_only} field="manager_state" label="State" options={states} fullWidth />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField disabled={is_read_only} field="manager_zip" label="Zip" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_email" label="Email" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_office_number" label="Office Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_mobile_number" label="Mobile Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_fax_number" label="Fax Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_website" label="Website" fullWidth />
                                    </Grid>
                                </Grid>
                                <PartnersContactList budgets={budgets} classes={classes} />
                            </Grid>

                            <Grid item xs={12} md={8} lg={4} xl={4}>
                                <TextField
                                    multiline
                                    rows={6}
                                    maxRows={20}
                                    eventHandle={this.editAppropriation}
                                    disabled={!(authState && authState.user && authState.user.role === "admin")}
                                    field="appropriation_language"
                                    label="Appropriation Language"
                                    fullWidth
                                />
                                <TextField
                                    multiline
                                    rows={6}
                                    maxRows={20}
                                    disabled={!(authState && authState.user && authState.user.role === "admin")}
                                    field="additional_legislative_changes"
                                    label="Additional Legislative Changes"
                                    fullWidth
                                />
                                <TextField
                                    multiline
                                    rows={4}
                                    maxRows={20}
                                    disabled={true}
                                    field="legal_citation"
                                    label="Legal Citation"
                                    fullWidth
                                />
                                <CheckboxGroup
                                    field="eco_regions"
                                    row={true}
                                    width={205}
                                    disabled={is_read_only}
                                    options={MAKE_OPTIONS([
                                        "Forest / Prairie Transition",
                                        "Metro / Urban",
                                        "Northern Forest",
                                        "Prairie",
                                        "Southeast Forest"
                                    ])}>
                                    <HelpLabel
                                        showLabel={true}
                                        inputLabel="Eco regions in which work will take place"
                                        helpText={
                                            <div>
                                                Check all that apply.
                                                <br />
                                                <br />
                                                Selections made for Regions will trigger unique questions throughout
                                                the application, including the control fields in the Output Tables
                                                Tab.
                                                <br />
                                                <br />
                                                <a
                                                    href="https://www.lsohc.leg.mn/materials/resource_doc_plan/lsohc_county_city.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    Region Map
                                                </a>
                                            </div>
                                        }
                                    />
                                </CheckboxGroup>
                                <CheckboxGroup
                                    field="activity_types"
                                    row={true}
                                    width={205}
                                    disabled={is_read_only}
                                    eventHandle={this.applyActivityOther}
                                    options={MAKE_OPTIONS([
                                        "Enhance",
                                        "Protect in Easement",
                                        "Protect in Fee",
                                        "Restore",
                                        "Other"
                                    ])}
                                >
                                    <HelpLabel
                                        inputLabel="Activity types"
                                        showLabel={true}
                                        helpText={
                                            <div>
                                                Check all that apply.
                                                <br />
                                                <br />
                                                Selections made for Activity type will trigger unique questions
                                                throughout the application, including the control fields in the
                                                Output Tables Tab.
                                            </div>
                                        }
                                    />
                                </CheckboxGroup>
                                {showOther && (
                                    <TextField
                                        field="activity_types_other"
                                        disabled={is_read_only}
                                        label="What is your other activity type?"
                                        fullWidth
                                    />
                                )}
                                <CheckboxGroup
                                    field="priority_resources_activity"
                                    row={true}
                                    disabled={is_read_only}
                                    width={205}
                                    options={MAKE_OPTIONS(["Forest", "Habitat", "Prairie", "Wetlands"])}
                                >
                                    <HelpLabel
                                        inputLabel="Priority resources addressed by activity"
                                        showLabel={true}
                                        helpText={
                                            <div>
                                                Check all that apply.
                                                <br />
                                                <br />
                                                Selections made for Priority resources will trigger unique questions
                                                throughout the application, including the control fields in the
                                                Output Tables Tab.
                                            </div>
                                        }
                                    />
                                </CheckboxGroup>
                            </Grid>
                            <Grid item xs={12} xl={10} className={classes.rightAlign}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    onClick={() => this.setState({ draftClick: true, submitClicked: true })}
                                    className={classes.button}>
                                    Save Draft and Return to Dashboard
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    color="primary"
                                    onClick={() => this.setState({ draftClick: false, submitClicked: true })}>
                                    Save and Proceed to Narrative <ChevronRightIcon />
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Form>
        );
    }
}

GeneralTab = connect(
    (state, ownProps) => ({
        authState: state.auth
    }),
    {
        ...FinalReport.actions,
        ...AdminTable.actions
    }
)(GeneralTab);

export default withStyles(styles)(withRouter(GeneralTab));
